import script from "./banner.vue?vue&type=script&setup=true&lang=js"
export * from "./banner.vue?vue&type=script&setup=true&lang=js"

import "./banner.vue?vue&type=style&index=0&id=127fbd66&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-127fbd66"]])

export default __exports__